import styled, { StyledComponentProps } from 'styled-components';

interface ContainerProps extends StyledComponentProps<'section', any, {}, never> {
  hasSingleChild?: boolean;
}

export const Container = styled.section<ContainerProps>`
  display: flex;
  justify-content: ${({ hasSingleChild }) => (hasSingleChild ? 'flex-start' : 'space-evenly')};
  flex-wrap: wrap;

`;

export const Score = styled.div`
  text-align: center;
  width: 57px;
  height: 48px;
  font-size: 9px;
  font-weight: bold;
  border: solid 1px #999999;
  color: ${({ theme }) => theme.starsFilter.color};
  margin-top: 8px;
  border-radius: 8px;
  padding-top: 7px;
  cursor: pointer;
  
  &.active {
    border: solid 1px #666666;
    background-color: ${({ theme }) => theme.primaryBackgroundColor};
    color: ${({ theme }) => theme.primaryColor};
  }
`;

export const ScoreText = styled.span`
  font-size: 9px;
  font-weight: normal;
  color: ${({ theme }) => theme.starsFilter.color};

  &.active {
    color: ${({ theme }) => theme.primaryColor};
  }
`;